export var YospaceEnvironment = /*#__PURE__*/ function(YospaceEnvironment) {
    YospaceEnvironment["PRODUCTION"] = "PRODUCTION";
    YospaceEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    return YospaceEnvironment;
}({});

//# sourceMappingURL=yospace.enums.js.map